import { render, staticRenderFns } from "./refertiShare.vue?vue&type=template&id=1873c294&"
import script from "./refertiShare.vue?vue&type=script&lang=js&"
export * from "./refertiShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports